type LineFieldProps = {
  /** Unique per page, e.g. "contact-name". */
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: string;
  placeholder?: string;
  autoComplete?: string;
  multiline?: boolean;
  rows?: number;
  required?: boolean;
};

/**
 * Underline input (`.is-line-field`, styles in patterns.css). Dark-panel colours
 * by default; wrap in `.is-line-fields--light` on paper.
 */
const LineField = ({
  id,
  label,
  value,
  onChange,
  error,
  type = "text",
  placeholder,
  autoComplete,
  multiline,
  rows = 3,
  required,
}: LineFieldProps) => {
  const errorId = `${id}-error`;
  const common = {
    id,
    value,
    placeholder,
    required,
    className: "is-line-field__input",
    "aria-invalid": error ? true : undefined,
    "aria-describedby": error ? errorId : undefined,
  };
  return (
    <div className="is-line-field">
      <label htmlFor={id} className="is-line-field__label">
        {label}
      </label>
      {multiline ? (
        <textarea {...common} rows={rows} onChange={(e) => onChange(e.target.value)} />
      ) : (
        <input {...common} type={type} autoComplete={autoComplete} onChange={(e) => onChange(e.target.value)} />
      )}
      {error && (
        <span id={errorId} className="is-line-field__error">
          {error}
        </span>
      )}
    </div>
  );
};

export default LineField;
